<template>
  <header class="header">
    <TheHeaderMobile v-if="isMobile" />
    <div class="header__container" v-show="isOpen">
      <TheHeaderTopbar :display-type="'help'" />
      <TheHeaderNavbar />
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import TheHeaderMobile from './TheHeaderMobile'
import TheHeaderTopbar from './TheHeaderTopbar'
import TheHeaderNavbar from './TheHeaderNavbar'

export default {
  name: 'TheHeader',
  data () {
    return {}
  },
  components: {
    TheHeaderMobile,
    TheHeaderTopbar,
    TheHeaderNavbar
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      isOpen: 'header/getOpen'
    }),
    isMobile () {
      return this.device !== 'desktop'
    }
  },
  watch: {
    '$route' () {
      if (this.isOpen) {
        this.updateOpen(!this.isMobile)
      }
    },
    isMobile () {
      this.updateOpen(!this.isMobile)
    }
  },
  created () {
    this.updateOpen(!this.isMobile)
  },

  methods: {
    ...mapActions({
      updateOpen: 'header/updateOpen'
    })
  }
}
</script>

<style lang="scss">
  .header{
    @media print {
      display: none !important;
    }
    position: relative;
    z-index: 1;
    &__container{
      @include media("small-medium"){
        flex-direction: column-reverse;
      }
      @include media("large"){
        flex-direction: column;
      }

      display: flex;

      > *{
        flex: 0 1 auto;
      }
    }
  }
</style>
